function createObjectWithProperties(originalObj: any, properties: any): any {
  const result: { [key: keyof typeof properties]: any } = {};
  for (const property of properties) {
    if (property in originalObj) {
      result[property] = originalObj[property];
    }
  }
  return result;
}

export default createObjectWithProperties;
